// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    BestFitPharmacyRequest,
    BestFitPharmacyRequestSearchRequest,
    BestFitPharmacyResultSearchRequest,
    GatewayError,
    PharmacyBiRequest,
    PharmacyBiRequestSearchRequest,
    PharmacyBiResultSearchRequest,
    PharmacyCardFinderRequest,
    PharmacyCardFinderRequestSearchRequest,
    PharmacyCardFinderResultSearchRequest,
    PharmacyCardFinderV2RequestModel,
    PharmacyV1BestFitRequestSearchPharmacyV1BestFitRequestSearchDefaultResponse,
    PharmacyV1BestFitResultSearchPharmacyV1BestFitResultSearchDefaultResponse,
    PharmacyV1PharmacyBiRequestSearchPharmacyV1PharmacyBiRequestSearchDefaultResponse,
    PharmacyV1PharmacyBiResultSearchPharmacyV1PharmacyBiResultSearchDefaultResponse,
    PharmacyV1PharmacyV1BestFitDefaultResponse,
    PharmacyV1PharmacyV1CardFinderDefaultResponse,
    PharmacyV1PharmacyV1CardFinderRequestSearchDefaultResponse,
    PharmacyV1PharmacyV1CardFinderResultSearchDefaultResponse,
    PharmacyV1PharmacyV1PharmacyBiDefaultResponse,
    PharmacyV1TripleCheckRequestResponse,
    PharmacyV1TripleCheckTransactionSearchResponse,
    PharmacyV2CardFinderRequestResponse,
    TripleCheckRequestModel,
    TripleCheckTransactionSearchRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePharmacyApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param pharmacyCardFinderV2RequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardFinderV2Request (pharmacyCardFinderV2RequestModel: PharmacyCardFinderV2RequestModel, xProgramId?: string): Promise<AxiosResponse<PharmacyV2CardFinderRequestResponse>> {
        const _url_ = '/edge/pharmacy/v2/CardFinder/request';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyCardFinderV2RequestModel' is not null or undefined
        if (pharmacyCardFinderV2RequestModel === null || pharmacyCardFinderV2RequestModel === undefined) {
            throw new Error('Required parameter pharmacyCardFinderV2RequestModel was null or undefined when calling cardFinderV2Request.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyCardFinderV2RequestModel, "PharmacyCardFinderV2RequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV2CardFinderRequestResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV2CardFinderRequestResponse");
        }
        return response;
    }
    /**
     * 
     * @param bestFitPharmacyRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1BestFit (bestFitPharmacyRequest: BestFitPharmacyRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1PharmacyV1BestFitDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/BestFit';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'bestFitPharmacyRequest' is not null or undefined
        if (bestFitPharmacyRequest === null || bestFitPharmacyRequest === undefined) {
            throw new Error('Required parameter bestFitPharmacyRequest was null or undefined when calling pharmacyV1BestFit.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(bestFitPharmacyRequest, "BestFitPharmacyRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1PharmacyV1BestFitDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyV1BestFitDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param bestFitPharmacyRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1BestFitRequestSearch (bestFitPharmacyRequestSearchRequest: BestFitPharmacyRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1BestFitRequestSearchPharmacyV1BestFitRequestSearchDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/BestFitRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'bestFitPharmacyRequestSearchRequest' is not null or undefined
        if (bestFitPharmacyRequestSearchRequest === null || bestFitPharmacyRequestSearchRequest === undefined) {
            throw new Error('Required parameter bestFitPharmacyRequestSearchRequest was null or undefined when calling pharmacyV1BestFitRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(bestFitPharmacyRequestSearchRequest, "BestFitPharmacyRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1BestFitRequestSearchPharmacyV1BestFitRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1BestFitRequestSearchPharmacyV1BestFitRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param bestFitPharmacyResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1BestFitResultSearch (bestFitPharmacyResultSearchRequest: BestFitPharmacyResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1BestFitResultSearchPharmacyV1BestFitResultSearchDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/BestFitResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'bestFitPharmacyResultSearchRequest' is not null or undefined
        if (bestFitPharmacyResultSearchRequest === null || bestFitPharmacyResultSearchRequest === undefined) {
            throw new Error('Required parameter bestFitPharmacyResultSearchRequest was null or undefined when calling pharmacyV1BestFitResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(bestFitPharmacyResultSearchRequest, "BestFitPharmacyResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1BestFitResultSearchPharmacyV1BestFitResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1BestFitResultSearchPharmacyV1BestFitResultSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param pharmacyCardFinderRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1CardFinder (pharmacyCardFinderRequest: PharmacyCardFinderRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1PharmacyV1CardFinderDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/CardFinder';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyCardFinderRequest' is not null or undefined
        if (pharmacyCardFinderRequest === null || pharmacyCardFinderRequest === undefined) {
            throw new Error('Required parameter pharmacyCardFinderRequest was null or undefined when calling pharmacyV1CardFinder.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyCardFinderRequest, "PharmacyCardFinderRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1PharmacyV1CardFinderDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyV1CardFinderDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param pharmacyCardFinderRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1CardFinderRequestSearch (pharmacyCardFinderRequestSearchRequest: PharmacyCardFinderRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1PharmacyV1CardFinderRequestSearchDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/CardFinderRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyCardFinderRequestSearchRequest' is not null or undefined
        if (pharmacyCardFinderRequestSearchRequest === null || pharmacyCardFinderRequestSearchRequest === undefined) {
            throw new Error('Required parameter pharmacyCardFinderRequestSearchRequest was null or undefined when calling pharmacyV1CardFinderRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyCardFinderRequestSearchRequest, "PharmacyCardFinderRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1PharmacyV1CardFinderRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyV1CardFinderRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param pharmacyCardFinderResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1CardFinderResultSearch (pharmacyCardFinderResultSearchRequest: PharmacyCardFinderResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1PharmacyV1CardFinderResultSearchDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/CardFinderResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyCardFinderResultSearchRequest' is not null or undefined
        if (pharmacyCardFinderResultSearchRequest === null || pharmacyCardFinderResultSearchRequest === undefined) {
            throw new Error('Required parameter pharmacyCardFinderResultSearchRequest was null or undefined when calling pharmacyV1CardFinderResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyCardFinderResultSearchRequest, "PharmacyCardFinderResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1PharmacyV1CardFinderResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyV1CardFinderResultSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param pharmacyBiRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1PharmacyBi (pharmacyBiRequest: PharmacyBiRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1PharmacyV1PharmacyBiDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/PharmacyBi';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyBiRequest' is not null or undefined
        if (pharmacyBiRequest === null || pharmacyBiRequest === undefined) {
            throw new Error('Required parameter pharmacyBiRequest was null or undefined when calling pharmacyV1PharmacyBi.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyBiRequest, "PharmacyBiRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1PharmacyV1PharmacyBiDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyV1PharmacyBiDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param pharmacyBiRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1PharmacyBiRequestSearch (pharmacyBiRequestSearchRequest: PharmacyBiRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1PharmacyBiRequestSearchPharmacyV1PharmacyBiRequestSearchDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/PharmacyBiRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyBiRequestSearchRequest' is not null or undefined
        if (pharmacyBiRequestSearchRequest === null || pharmacyBiRequestSearchRequest === undefined) {
            throw new Error('Required parameter pharmacyBiRequestSearchRequest was null or undefined when calling pharmacyV1PharmacyBiRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyBiRequestSearchRequest, "PharmacyBiRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1PharmacyBiRequestSearchPharmacyV1PharmacyBiRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyBiRequestSearchPharmacyV1PharmacyBiRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param pharmacyBiResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pharmacyV1PharmacyBiResultSearch (pharmacyBiResultSearchRequest: PharmacyBiResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1PharmacyBiResultSearchPharmacyV1PharmacyBiResultSearchDefaultResponse>> {
        const _url_ = '/edge/pharmacy/v1/PharmacyBiResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyBiResultSearchRequest' is not null or undefined
        if (pharmacyBiResultSearchRequest === null || pharmacyBiResultSearchRequest === undefined) {
            throw new Error('Required parameter pharmacyBiResultSearchRequest was null or undefined when calling pharmacyV1PharmacyBiResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyBiResultSearchRequest, "PharmacyBiResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1PharmacyBiResultSearchPharmacyV1PharmacyBiResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyBiResultSearchPharmacyV1PharmacyBiResultSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param tripleCheckRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async tripleCheckRequest (tripleCheckRequestModel: TripleCheckRequestModel, xProgramId?: string): Promise<AxiosResponse<PharmacyV1TripleCheckRequestResponse>> {
        const _url_ = '/edge/pharmacy/v1/TripleCheck/request';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tripleCheckRequestModel' is not null or undefined
        if (tripleCheckRequestModel === null || tripleCheckRequestModel === undefined) {
            throw new Error('Required parameter tripleCheckRequestModel was null or undefined when calling tripleCheckRequest.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tripleCheckRequestModel, "TripleCheckRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1TripleCheckRequestResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1TripleCheckRequestResponse");
        }
        return response;
    }
    /**
     * 
     * @param tripleCheckTransactionSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async tripleCheckTransactionSearch (tripleCheckTransactionSearchRequest: TripleCheckTransactionSearchRequest, xProgramId?: string): Promise<AxiosResponse<PharmacyV1TripleCheckTransactionSearchResponse>> {
        const _url_ = '/edge/pharmacy/v1/TripleCheck/transactionSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tripleCheckTransactionSearchRequest' is not null or undefined
        if (tripleCheckTransactionSearchRequest === null || tripleCheckTransactionSearchRequest === undefined) {
            throw new Error('Required parameter tripleCheckTransactionSearchRequest was null or undefined when calling tripleCheckTransactionSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tripleCheckTransactionSearchRequest, "TripleCheckTransactionSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyV1TripleCheckTransactionSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1TripleCheckTransactionSearchResponse");
        }
        return response;
    }
}
